import { motion } from 'framer-motion'
import type { NotesPyramid as NotesPyramidType } from '@/types'

interface NotesPyramidProps {
  notes: NotesPyramidType
}

const layers = [
  { key: 'top', label: 'Top', description: 'First impression — evaporates in minutes' },
  { key: 'heart', label: 'Heart', description: 'The character — lasts for hours' },
  { key: 'base', label: 'Base', description: 'The lingering memory — stays all day' },
] as const

export function NotesPyramid({ notes }: NotesPyramidProps) {
  return (
    <div className="space-y-6">
      {layers.map((layer, index) => {
        const items = notes[layer.key]
        return (
          <motion.div
            key={layer.key}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.15 }}
            className="border-b border-ink/10 pb-6"
          >
            <div className="mb-3 flex items-baseline justify-between">
              <h4 className="font-display text-lg normal-case text-carbon">{layer.label}</h4>
              <span className="font-condensed text-xs uppercase tracking-[0.15em] text-carbon/50">{layer.description}</span>
            </div>
            <div className="flex flex-wrap gap-3">
              {items.map((note) => (
                <span
                  key={note}
                  className="rounded-sm border border-ink/10 px-3 py-1.5 text-sm text-carbon/70"
                >
                  {note}
                </span>
              ))}
            </div>
          </motion.div>
        )
      })}
    </div>
  )
}
